module.exports = {
  LOG_FILE_NAME: 'elk-refresh-logs.log',
  ACCESS_LOG_FILE_NAME: 'access.log',
  RELATIVE_LOG_PATH: '../logs',
  RELATIVE_SCRIPT_LOG_PATH: '../../../logs',
  NO_OF_DAYS: 6,
  PROCESS_NAMES: [
    'homerefresh',
    'cartrefresh',
    'loggedinrefresh',
    'myaccountrefresh',
    'sizeguiderefresh',
    'landingServerRefresh',
    'gameServerRefresh',
    'topShopperServerRefresh'
  ]
};
